function nearlyEqual(a, b, epsilon = 1e-10) {
  return Math.abs(a - b) < epsilon;
}

function greaterOrEqual(a, b, epsilon = 1e-10) {
  return a > b || nearlyEqual(a, b, epsilon);
}

function lessOrEqual(a, b, epsilon = 1e-10) {
  return a < b || nearlyEqual(a, b, epsilon);
}

function roundTo(num, decimals = 2) {
  const factor = Math.pow(10, decimals);
  // cộng thêm epsilon để tránh sai số kiểu 0.7949999999
  const result = Math.round((num + Number.EPSILON) * factor) / factor;
  if (result) return result;
  return 0;
}

function nearlyEqualVector(a, b, epsilon = 1e-10) {
  return (
    Math.abs(a.x - b.x) < epsilon &&
    Math.abs(a.y - b.y) < epsilon &&
    Math.abs(a.z - b.z) < epsilon
  );
}

function roundLeft(num, keep) {
  const len = Math.floor(Math.log10(num)) + 1;
  const pow = 10 ** (len - keep + 1);
  const result = Math.round(num / pow) * pow;
  return result;
}

export {
  nearlyEqual,
  greaterOrEqual,
  lessOrEqual,
  roundTo,
  nearlyEqualVector,
  roundLeft,
};
